import React from 'react';
import ReactTooltip from 'react-tooltip';
import MoneyFormat from 'common/components/moneyFormat/MoneyFormat';
import styles from './InfoCard.module.scss';

type Props = {
    /** Texto descritivo do card (ex: "CUSTO TOTAL DE DESPESAS") */
    label: string | React.ReactNode;
    /** Valor a mostrar (numero, string ou ReactNode) */
    value: number | string | React.ReactNode;
    /** Icone SVG (path do ficheiro) */
    icon?: string;
    /** Cor de fundo do card */
    backgroundColor: string;
    /** Formatar como dinheiro (default: false) */
    isMoney?: boolean;
    /** Formatar como km com 3 decimais (default: false) */
    isKm?: boolean;
    /** Classes CSS adicionais */
    className?: string;
    /** Texto secundário (canto superior direito em desktop, abaixo do label em mobile) */
    subtitle?: string;
    /** Tooltip no ícone de info junto ao label */
    labelTooltip?: string;
    /** Handler de click */
    onClick?: () => void;
};

const InfoCard: React.FC<Props> = ({
    label,
    value,
    icon,
    backgroundColor,
    isMoney = false,
    isKm = false,
    className,
    subtitle,
    labelTooltip,
    onClick
}) => {
    const renderValue = () => {
        if (typeof value !== 'number' && typeof value !== 'string') {
            return value;
        }
        if (isMoney || isKm) {
            return (
                <MoneyFormat
                    value={value}
                    fixedDecimalScale={true}
                    decimalScale={isKm ? 3 : 2}
                    suffix={isKm ? '' : undefined}
                />
            );
        }
        return value;
    };

    return (
        <div
            className={`${styles.infoCard} ${subtitle ? styles.hasSubtitle : ''} ${className || ''}`}
            style={{ backgroundColor }}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
        >
            {/* Icon - reordenado via CSS em mobile */}
            {icon && (
                <div
                    className={styles.icon}
                    style={{ backgroundImage: `url(${icon})` }}
                />
            )}
            {/* Label + Subtitle agrupados para layout responsivo */}
            <div className={styles.textGroup}>
                <span className={styles.label} title={typeof label === 'string' ? label : undefined}>
                    {label}
                    {labelTooltip && (
                        <span className={styles.labelInfo} data-tip={labelTooltip} data-for={`info-${typeof label === 'string' ? label : 'card'}`}>
                            i
                        </span>
                    )}
                </span>
                {labelTooltip && <ReactTooltip id={`info-${typeof label === 'string' ? label : 'card'}`} effect="solid" place="bottom" type="dark" />}
                {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
            </div>
            {/* Valor */}
            <span className={styles.value}>{renderValue()}</span>
        </div>
    );
};

export default InfoCard;
